const centura_webshop = window.centura_webshop || {};
window.centura_webshop = centura_webshop;

centura_webshop.ShopSearch = class ShopSearch {
    constructor(wrapper) {
        this.wrapper = $(wrapper);
        this.min_chars = 3;
        this.max_recent = 4;
        this.debounce_ms = 300;
        this._debounce_timer = null;
        this.init();
    }

    init() {
        this.bind_events();
    }

    bind_events() {
        const input = this.wrapper.find('.webshop-search-input');
        const dropdown = this.wrapper.find('.webshop-search-dropdown');
        const clearBtn = this.wrapper.find('.webshop-search-clear');

        const toggleClear = () => clearBtn.toggle(!!input.val().trim());

        input.on('input', () => {
            clearTimeout(this._debounce_timer);
            toggleClear();
            const query = input.val().trim();

            if (!query) {
                if (this._has_search_param()) {
                    this._clear_search();
                } else {
                    this._show_recent_searches();
                }
                return;
            }

            if (query.length < this.min_chars) {
                this._show_recent_searches();
                return;
            }

            this._debounce_timer = setTimeout(
                () => this._search(query),
                this.debounce_ms
            );
        });

        clearBtn.on('click', () => {
            input.trigger('focus');
            this._clear_search();
        });

        input.on('focus', () => {
            if (!input.val().trim()) {
                this._show_recent_searches();
            }
            dropdown.addClass('show');
        });

        $(document).on('click', (e) => {
            if (!this.wrapper[0].contains(e.target)) {
                dropdown.removeClass('show');
            }
        });

        input.on('keydown', (e) => {
            if (e.key === 'Enter') {
                const query = input.val().trim();
                if (query) {
                    this._save_recent_search(query);
                    window.location.href = `/shop/products?search=${encodeURIComponent(
                        query
                    )}`;
                } else if (this._has_search_param()) {
                    this._clear_search();
                }
            }
        });
    }

    _has_search_param() {
        return new URL(window.location.href).searchParams.has('search');
    }

    _clear_search() {
        const input = this.wrapper.find('.webshop-search-input');
        const dropdown = this.wrapper.find('.webshop-search-dropdown');
        const clearBtn = this.wrapper.find('.webshop-search-clear');

        input.val('');
        clearBtn.hide();
        dropdown.removeClass('show');

        const url = new URL(window.location.href);
        if (!url.searchParams.has('search')) {
            return;
        }
        url.searchParams.delete('search');
        window.location.href = url.toString();
    }

    _search(query) {
        frappe.call({
            method: 'centura_webshop.api.search_products',
            args: { query },
            callback: (r) => {
                if (r.message) {
                    this._render_results(r.message, query);
                }
            }
        });
    }

    _render_results(results, query) {
        const dropdown = this.wrapper.find('.webshop-search-dropdown');
        let html = '';

        if (results.products && results.products.length) {
            html += `<div class="webshop-search-section-title">${__(
                'Products'
            )}</div>`;
            results.products.forEach((p) => {
                const image =
                    p.website_image ||
                    p.image ||
                    '/assets/centura_webshop/images/placeholder.svg';
                html += `
					<a href="/${frappe.utils.escape_html(p.route)}" class="webshop-search-result">
						<img src="${frappe.utils.escape_html(image)}" alt="${frappe.utils.escape_html(
                            p.web_item_name
                        )}" width="48" height="48" loading="lazy">
						<div class="webshop-result-info">
							<div class="webshop-result-name">${frappe.utils.escape_html(
                                p.web_item_name
                            )}</div>
							<div class="webshop-result-category">${frappe.utils.escape_html(
                                p.item_group || ''
                            )}</div>
						</div>
					</a>
				`;
            });
        }

        if (results.categories && results.categories.length) {
            html += `<div class="webshop-search-section-title">${__(
                'Categories'
            )}</div>`;
            html += '<div class="webshop-recent-searches">';
            results.categories.forEach((c) => {
                html += `<a href="/${frappe.utils.escape_html(
                    c.route
                )}" class="webshop-recent-chip">${frappe.utils.escape_html(
                    c.name
                )}</a>`;
            });
            html += '</div>';
        }

        if (!html) {
            html = `<div class="webshop-search-empty-state">`;
            html += `<div class="p-3 text-muted text-center">${__(
                'No results for "{0}"',
                [frappe.utils.escape_html(query)]
            )}</div>`;

            if (results.popular_products && results.popular_products.length) {
                html += `<div class="webshop-search-section-title">${__(
                    'Popular Products'
                )}</div>`;
                results.popular_products.forEach((p) => {
                    const image =
                        p.website_image ||
                        '/assets/centura_webshop/images/placeholder.svg';
                    html += `
						<a href="/${frappe.utils.escape_html(p.route)}" class="webshop-search-result">
							<img src="${frappe.utils.escape_html(image)}" alt="${frappe.utils.escape_html(
                                p.web_item_name
                            )}" width="48" height="48" loading="lazy">
							<div class="webshop-result-info">
								<div class="webshop-result-name">${frappe.utils.escape_html(
                                    p.web_item_name
                                )}</div>
								<div class="webshop-result-category">${frappe.utils.escape_html(
                                    p.item_group || ''
                                )}</div>
							</div>
						</a>
					`;
                });
            }

            if (results.top_categories && results.top_categories.length) {
                html += `<div class="webshop-search-section-title">${__(
                    'Browse Categories'
                )}</div>`;
                html += '<div class="webshop-recent-searches">';
                results.top_categories.forEach((c) => {
                    html += `<a href="/${frappe.utils.escape_html(
                        c.route
                    )}" class="webshop-recent-chip">${frappe.utils.escape_html(
                        c.name
                    )}</a>`;
                });
                html += '</div>';
            }

            html += '</div>';
        }

        dropdown.html(html).addClass('show');
        const hasResults =
            (results.products && results.products.length) ||
            (results.categories && results.categories.length);
        if (hasResults) {
            this._save_recent_search(query);
        }
    }

    _show_recent_searches() {
        const searches = this._get_recent_searches();
        const dropdown = this.wrapper.find('.webshop-search-dropdown');

        if (!searches.length) {
            dropdown.removeClass('show');
            return;
        }

        let html = `<div class="webshop-search-section-title">${__(
            'Recent Searches'
        )}</div>`;
        html += '<div class="webshop-recent-searches">';
        searches.forEach((s) => {
            html += `<span class="webshop-recent-chip" data-search="${frappe.utils.escape_html(
                s
            )}">${frappe.utils.escape_html(s)}</span>`;
        });
        html += '</div>';

        dropdown.html(html).addClass('show');

        dropdown.find('.webshop-recent-chip').on('click', function () {
            const query = $(this).data('search');
            dropdown
                .closest('.webshop-search')
                .find('.webshop-search-input')
                .val(query);
            window.location.href = `/shop/products?search=${encodeURIComponent(
                query
            )}`;
        });
    }

    _save_recent_search(query) {
        if (!query) return;
        let searches = this._get_recent_searches();
        searches = searches.filter((s) => s !== query);
        searches.unshift(query);
        searches = searches.slice(0, this.max_recent);
        localStorage.setItem('ew_recent_searches', JSON.stringify(searches));
    }

    _get_recent_searches() {
        try {
            return JSON.parse(
                localStorage.getItem('ew_recent_searches') || '[]'
            );
        } catch {
            return [];
        }
    }
};

frappe.ready(() => {
    $('.webshop-search').each(function () {
        new centura_webshop.ShopSearch(this);
    });
});
